import React from "react";
import PropTypes from 'prop-types';
import _ from "lodash";

const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

const OrderItem = ({ id, truck_name, truck_units, order_items_trucks, status, status_string }) => {
    const grupped = order_items_trucks ? _.groupBy(order_items_trucks.sort((a, b) => a.sort - b.sort), (e) => {
        return e.order_item?.delivered_region ?? 'En granja'
    }) : {}

    return (
        <tr key={id}>
            <td className="text-center">{truck_name} <br /><span className={status == 'pending' ? 'badge rounded-pill bg-warning' : 'badge rounded-pill bg-success'}>{status_string}</span></td>
            <td>{parseInt(truck_units)} pzas</td>
            <td>{_.sumBy(order_items_trucks, (e) => {
                return Number(e.quantity);
            })} pzas
            </td>
            {false &&
                < td >
                    {
                        order_items_trucks.map(order_item_truck => (
                            <>
                                <i className="fas fa-user"></i>{" "}
                                {order_item_truck.order_item.order.client.company_name}<br />
                            </>))
                    }
                </td>
            }
            <td>
                {
                    Object.keys(grupped)
                        .map((key, idx) =>
                        (
                            <div key={'a' + grupped[key][0].id} className="mb-2">
                                <span className="badge bg-danger ps-1 pe-1 me-1 my-2 float-start">{idx + 1}</span>{" "}
                                <i className="far fa-calendar-alt"></i>{" "}
                                <b>Día {grupped[key][0].order_item?.delivery_date.substr(8)} Hrs. |{" "}
                                    {grupped[key][0].order_item?.delivered ? grupped[key][0].order_item?.delivered_region : 'En granja'} {grupped[key][0].order_item?.delivered ? grupped[key].order_item?.delivered_subregion : ''}  |{" "}
                                    {grupped[key].map(e => e.quantity + 'Pzas | ')}
                                </b> <br />
                                <i className="fas fa-map-pin"></i>{" "}
                                {grupped[key][0].order_item?.delivered ? grupped[key][0].order_item?.order?.delivery_address : ''}
                            </div>
                        )
                        )
                }
            </td>
            {false &&
                <td>
                    {
                        order_items_trucks.map(order_item_truck => (
                            <>
                                ${numberFormat.format(Number(order_item_truck.order_item.total_cost))} <br />
                            </>
                        ))
                    }
                </td>
            }
        </tr >
    )
}

OrderItem.propTypes = {
    id: PropTypes.number,
    truck_name: PropTypes.string,
    truck_units: PropTypes.number,
    order_items_trucks: PropTypes.array,
    status: PropTypes.string,
    status_string: PropTypes.string,
};

export {
    OrderItem
};